interface SvgUriImageProps {
    uri: string;
    height: number;
    width: number;
}

export const SvgUri = ({ uri, height, width }: SvgUriImageProps) => {
    return <img src={uri} height={height} width={width} alt="" />;
};
